import { requests } from '../httpClient';

export const FamEnrolment = {
    getEnrolmentYearsAsync: () => requests.get(`FamEnrolment`),
    basketAsync: () => requests.post(`FamEnrolment/ReEnrolBasket`, {}),
    nextYearEnrolBasketAsync: () => requests.post(`FamEnrolment/NextYearEnrolBasket`, {})
};
